module.exports = __webpack_public_path__ + "media/music/piano_chords_4-fb10dc20.mp3";